import { Flex, Layout } from 'antd';
import { ClientInfoModal } from 'client-app/components/client/client-info-modal';
import { ClientUserMenu } from 'client-app/components/client/client-user-menu';
import { ClientOrdersSearch } from 'client-app/components/client-orders/client-orders-search';
import styles from './header.module.scss';

const { Header: AntHeader } = Layout;

export const Header = () => {
  return (
    <AntHeader className={styles.header}>
      <img src='/tankel.png' alt='Tankel Logistics' width={110} />
      <Flex className={styles.searchBar}>
        <ClientOrdersSearch />
      </Flex>
      <Flex align='center'>
        <ClientInfoModal />
        <ClientUserMenu />
      </Flex>
    </AntHeader>
  );
};
